import getConfig from 'next/config';

export const BASE_URL = getConfig()?.publicRuntimeConfig.baseUrl ?? '';
